import React, { forwardRef, useRef, useEffect, useState } from 'react'
import { THREE } from 'expo-three';
import { useBox } from '../../systems/Physics/hooks'
import useCollision from '../../hooks/useCollision'
import { useEvents } from '../../systems/World/hooks';
import { CHARACTER_EVENTS } from '../../systems/World/Events';

export default forwardRef(({
  hx = 4,
  hy = 4,
  rotate = 0,
  color = 'red',
  ...props
}, ref) => {
  let api
  let baseRef = ref || useRef();
  [baseRef, api] = useBox({}, ref)
  const [material] = useState(new THREE.MeshNormalMaterial({ color, transparent: true, opacity: 0.25, wireframe: false }))
  const spinRevertTrigger = useEvents(CHARACTER_EVENTS.EXTERNAL_SPIN_CHANGE)

  useCollision(collidedFixture => {
    const uuid = collidedFixture.GetBody().GetUserData().uuid
    api.revertSpin(uuid)
    spinRevertTrigger(uuid)
  }
  , baseRef.current?.uuid)

  return (
    <mesh
      ref={baseRef}
      rotation={[0, 0, 0]}
      {...props}
      userData={{ origin: props.position, pickable: true, hx: hx/2, hy: hy/2, rotate: false, angle: rotate }}
      material={material}
      // castShadow
    >
      <boxBufferGeometry args={[hx, 0.2, hy, 10]} />
      {/* <meshStandardMaterial color={'orange'} /> */}
    </mesh>
  )
})